import PersonalInfo from "../personal_info/PersonalInfo";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";

function PersonalLanding(){
    return(
        <div className="personal_landing">
            <Header />
            <PersonalInfo />
            <Footer />
        </div>
    )
}

export default PersonalLanding